import $ from 'jquery';
import 'slick-carousel';
import Formatters from '../helpers/formatters'
import {sgyConsumer} from "../lib/sgyCore/sgyConsumer.js";
import {sgyRegulations} from "../lib/sgyCore/sgyRegulations.js";
import ga4 from '../lib/ga-helper';
import extraValidatorsClass from './RetirementNeeds/extraValidatorsClass';

$(() => {
    const $readTerms = $('#read-terms'),
    $needsContainer = $('.calc-retirementneeds'),
    $needsForm = $(".js-calc-retirement-needs-form"),
    $preFormStep = $('#pre-form-step'),
    $needsFormRnBody = $needsForm.find('.rn_body'),
    $goToFormBtn = $('#go-to-form'),
    $backToPreForm = $('#back-to-pre-form'),
    $needsModal = $('#retirementneedsassumptions'),
    $retirementNeedsPartner = $('input[name=retirement-needs-partner]'),
    $retirementNeedsKnow = $('input[name=retirement-needs-know]'),
    $steps = $(".js-calc-retirement-needs-step"),
    $stepIndex = $(".js-calc-retirement-needs-index"),
    $stepNext = $(".js-calc-retirement-needs-next"),
    $stepBack = $(".js-calc-retirement-needs-back"),
    $retireAge = $(".js-calc-retirement-needs-retireage"),
    $incomeBox = $('.js-calc-retirement-needs-income-box'),
    $help = $('.js-calc-retirement-needs-help'),
    $income = $('.js-calc-retirement-needs-income'),
    $incomeFreq = $('.js-calc-retirement-needs-income-freq'),
    $frequency = $('.js-calc-retirement-needs-frequency'),
    $standard = $('.js-calc-retirement-needs-standard'),
    $budgets = $('.js-calc-retirement-needs-budgets'),
    $budgetsFreq = $('.js-calc-retirement-needs-budgets-freq'),
    $budgetsCustom = $('.js-calc-retirement-needs-expcards-custom'),
    $budgetsTotal = $('.js-calc-retirement-needs-budgets-total'),
    $cards = $('.js-calc-retirement-needs-expcards'),
    $dip = $('.js-calc-retirement-needs-dip'),
    $lumpsums = $('.js-calc-retirement-needs-lumpsums'),
    $lumpsumsBox = $('.js-calc-retirement-needs-lumpsum-box'),
    $lumpsumsSentence = $('.js-calc-retirement-needs-lumpsum-sentence'),
    $lumpsumTotal = $('.js-calc-retirement-needs-lumpsum-total'),
    $returns = $('.js-calc-retirement-needs-lumpsum-returns'),
    $inflation = $('.js-calc-retirement-needs-lumpsum-inflation'),
    $assReset = $('.js-calc-retirement-needs-ass-reset'),
    $results = $('.js-calc-retirement-needs-results'),
    $asfa = $('.js-calc-retirement-needs-asfa'),
    $reset = $('.js-rn_cta--reset'),
    $singleOrCoupleElement = $('#js-single-or-couple-element'),
    defaultBudgets = sgyRegulations.asfaRetirementBudgets,
    RetirementNeeds = {
        FoundationExtraValidator: new extraValidatorsClass($needsForm, $needsModal),
        // cant get access to RetirementNeeds.GA object below due to how the initializer function binds functions and values to RetirementNeeds
        // Cards: new cardClass($cards, RetirementNeeds.GA, $frequency, $standard, $status, $budgets, $budgetsTotal).updateCards,
        Cards: {
            updateCards() {
                $cards.each(function() {
                    var zone = $(this).data('zone');
                    if ($(this).val() == 'modest') {
                        $(this).data('singleModest', defaultBudgets.singleModest[zone]);
                        $(this).data('coupleModest', defaultBudgets.coupleModest[zone]);
                        if (RetirementNeeds.Form.couplesSelection === "no") {
                            $(this).parent('.rn-label_radio').find('.rn-radio__value').html(defaultBudgets.singleModest[zone].fromPeriod('week').toPeriod($frequency.val()).formatMoney(0));
                            $(this).parent('.rn-label_radio').find('.rn-radio__value').attr('org', defaultBudgets.singleModest[zone].fromPeriod('week').toPeriod($frequency.val()));
                        } else {
                            $(this).parent('.rn-label_radio').find('.rn-radio__value').html(defaultBudgets.coupleModest[zone].fromPeriod('week').toPeriod($frequency.val()).formatMoney(0));
                            $(this).parent('.rn-label_radio').find('.rn-radio__value').attr('org', defaultBudgets.coupleModest[zone].fromPeriod('week').toPeriod($frequency.val()));
                        }
                    } else if ($(this).val() == 'comfortable') {
                        $(this).data('singleComfortable', defaultBudgets.singleComfortable[zone]);
                        $(this).data('coupleComfortable', defaultBudgets.coupleComfortable[zone]);
                        if (RetirementNeeds.Form.couplesSelection === "no") {
                            $(this).parent('.rn-label_radio').find('.rn-radio__value').html(defaultBudgets.singleComfortable[zone].fromPeriod('week').toPeriod($frequency.val()).formatMoney(0));
                            $(this).parent('.rn-label_radio').find('.rn-radio__value').attr('org', defaultBudgets.singleComfortable[zone].fromPeriod('week').toPeriod($frequency.val()));
                        } else {
                            $(this).parent('.rn-label_radio').find('.rn-radio__value').html(defaultBudgets.coupleComfortable[zone].fromPeriod('week').toPeriod($frequency.val()).formatMoney(0));
                            $(this).parent('.rn-label_radio').find('.rn-radio__value').attr('org', defaultBudgets.coupleComfortable[zone].fromPeriod('week').toPeriod($frequency.val()));
                        }
                    }
                });
                let total = 0;
                if (RetirementNeeds.Form.couplesSelection === "no") {
                    $cards.filter('.js-expcard-active').each(function() {
                        if ($(this).val() == 'modest') {
                            total += parseFloat($(this).parent('.rn-label_radio').find('.rn-radio__value').attr('org'));
                            if ($(this)[0].hasAttribute('changed')) RetirementNeeds.GA.track('Retirement Needs Calculator', 'Step 2', 'rc-' + $(this).data('zone') + '-' + 'singlemodest');
                        } else if ($(this).val() == 'comfortable') {
                            total += parseFloat($(this).parent('.rn-label_radio').find('.rn-radio__value').attr('org'));
                            if ($(this)[0].hasAttribute('changed')) RetirementNeeds.GA.track('Retirement Needs Calculator', 'Step 2', 'rc-' + $(this).data('zone') + '-' + 'singlecomfortable');
                        } else {
                            if ($(this).parent('.rn-label_radio').find('.input-group-field').val() !== '') {
                                total += parseInt($(this).parent('.rn-label_radio').find('.input-group-field').val().reverseFormatMoney());
                            }
                        }
                    });
                } else {
                    $cards.filter('.js-expcard-active').each(function() {
                        if ($(this).val() == 'modest') {
                            total += parseFloat($(this).parent('.rn-label_radio').find('.rn-radio__value').attr('org'));
                            if ($(this)[0].hasAttribute('changed')) RetirementNeeds.GA.track('Retirement Needs Calculator', 'Step 2', 'rc-' + $(this).data('zone') + '-' + 'couplemodest');
                        } else if ($(this).val() == 'comfortable') {
                            total += parseFloat($(this).parent('.rn-label_radio').find('.rn-radio__value').attr('org'));
                            if ($(this)[0].hasAttribute('changed')) RetirementNeeds.GA.track('Retirement Needs Calculator', 'Step 2', 'rc-' + $(this).data('zone') + '-' + 'couplecomfortable');
                        } else {
                            if ($(this).parent('.rn-label_radio').find('.input-group-field').val() !== '') {
                                total += parseInt($(this).parent('.rn-label_radio').find('.input-group-field').val().reverseFormatMoney());
                            }
                        }
                    });
                }
                if (RetirementNeeds.Form.couplesSelection === "no") {
                    if($frequency.val() == 'week') $standard.html((defaultBudgets.singleComfortable.totals.weekly).formatMoney(0));
                    if($frequency.val() == 'fortnight') $standard.html((defaultBudgets.singleComfortable.totals.fortnightly).formatMoney(0));
                    if($frequency.val() == 'month') $standard.html((defaultBudgets.singleComfortable.totals.monthly).formatMoney(0));
                    if($frequency.val() == 'year') $standard.html((defaultBudgets.singleComfortable.totals.yearly).formatMoney(0));
                } else {
                    if($frequency.val() == 'week') $standard.html((defaultBudgets.coupleComfortable.totals.weekly).formatMoney(0));
                    if($frequency.val() == 'fortnight') $standard.html((defaultBudgets.coupleComfortable.totals.fortnightly).formatMoney(0));
                    if($frequency.val() == 'month') $standard.html((defaultBudgets.coupleComfortable.totals.monthly).formatMoney(0));
                    if($frequency.val() == 'year') $standard.html((defaultBudgets.coupleComfortable.totals.yearly).formatMoney(0));
                }
                $budgets.html(Math.round(total).formatMoney(0));
                $budgetsTotal.val(Math.round(total.fromPeriod($frequency.val()).toPeriod('year')));
            }
        },
        Lumpsums: {
            updateLumpsums() {
                let total = 0;
                $lumpsums.each(function() {
                    if ($(this).val() !== "") {
                        var num = $(this).val().reverseFormatMoney() //we remove dollar if dollar
                        num = parseInt(num);
                        total += num;
                    }
                });
                $lumpsumTotal.val(Math.round(total).formatMoneyNOD(0));
            }
        },
        FancyRadio: {
            init() {
                $('.rn-label_radio input').parent('label').addClass("r_off");
                $('.rn-label_radio input:checked').parent('label').removeClass("r_off").addClass("r_on");
                $('.rn-label_radio input').on('change', function() {
                    const $label = $(this).parent('label');
                    $('input[name=' + $(this).attr('name') + ']').parent('label').removeClass('r_off').removeClass('r_on');
                    if (this.checked) {
                        $label.addClass('r_on').removeClass('r_off');
                    } else {
                        $label.addClass('r_off').removeClass('r_on');
                    }
                });
                $('.rn-label_radio input').focus(function() {
                    $(this).closest('label').addClass('r_focus');
                });
                $('.rn-label_radio input').blur(function() {
                    $(this).closest('label').removeClass('r_focus');
                });
            },
            reset() {
                $('.rn-label_radio input:checked').prop('checked', false).parent().removeClass('r_on').addClass("r_off")
            }
        },
        TooltipFix: {
            init() {
                $('.tooltip').on('click', function() {
                    $(this).foundation('hide');
                });
            }
        },
        Inputs: {
            init() {
                // Force validation class onto partner label if its associated radio inputs have an error
                const $partnerLabel = $('#js-partner-label')
                $('.rn_step-one .js-calc-retirement-needs-next').on('click', function() {
                    setTimeout(function() {
                        $retirementNeedsPartner.each(function(id, el) {
                            if ($(el).hasClass('is-invalid-input')) { // Check if a partner radio has an error
                                $partnerLabel.addClass('is-invalid-label')
                            }
                        })
                    }, 100)
                })
                $retirementNeedsPartner.on('click', function() {
                    $partnerLabel.removeClass('is-invalid-label')
                })
                $retirementNeedsKnow.each(function(id, el) {
                    $(el).on('click', function() {
                        RetirementNeeds.Form.retirementNeedsKnowSelection = $(el).val()
                        if (RetirementNeeds.Form.retirementNeedsKnowSelection === 'know') {
                            $help.hide()
                            $incomeBox.show()
                        }
                        if (RetirementNeeds.Form.retirementNeedsKnowSelection === 'dont-know') {
                            $help.show()
                            $incomeBox.hide()
                        }
                    })
                })
                $dip.on('change', function() {
                    if ($(this).val() == "wont") {
                        $lumpsumsBox.slideUp();
                        $lumpsumsSentence.hide();
                    } else {
                        $lumpsumsBox.slideDown();
                        $lumpsumsSentence.show();
                    }
                });
                $cards.on('click', function(e) {
                    var siblings = $(this).parents('.rn-radio').find($cards);
                    var expcardContainer = $(this).parents('.rn_slider__item').find('.rn_slider--image');
                    if ($(this).val() == 'modest') {
                        expcardContainer.addClass('modest').removeClass('comfortable');
                        RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 3', 'Budget modest' + ' - ' + $(this).attr('name'));
                    } else if ($(this).val() == 'comfortable') {
                        expcardContainer.addClass('comfortable').removeClass('modest');
                        RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 3', 'Budget comfortable' + ' - ' + $(this).attr('name'));
                    } else {
                        RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 3', 'Budget custom' + ' - ' + $(this).attr('name'));
                    }
                    siblings.removeClass('js-expcard-active');
                    $(this).addClass('js-expcard-active');
                    $(this).attr('changed', 'changed');
                    $cards.removeAttr('changed');
                    RetirementNeeds.Cards.updateCards();
                });
                $income.on('blur', function() {
                    var num = $(this).val().reverseFormatMoney() //we remove dollar if dollar
                    num = parseInt(num).formatMoney(0);
                    $(this).val(num);
                });
                $incomeFreq.on('change', function() {
                    var max = 300000;
                    max = max.fromPeriod('year').toPeriod($(this).val());
                    $income.attr('data-max', max).trigger('change').trigger('blur');
                });
                $lumpsums.on('blur', function() {
                    var num = $(this).val().reverseFormatMoney() //we remove dollar if dollar
                    num = parseInt(num).formatMoneyNOD(0);
                    $(this).val(num);
                    RetirementNeeds.Lumpsums.updateLumpsums();
                });
                $budgetsCustom.on('blur', function() {
                    var num = $(this).val().reverseFormatMoney() //we remove dollar if dollar
                    num = parseInt(num).formatMoney(0);
                    $(this).val(num);
                    RetirementNeeds.Cards.updateCards();
                });
                $budgetsCustom.on('click', function() {
                    $(this).parents('label').find('input[type="radio"]').trigger('click');
                });
                // $status.on('change blur', function() {
                //     RetirementNeeds.Cards.updateCards();
                // });
                $frequency.on('change', function() {
                    var frq = $(this).val(); //we remove dollar if dollar
                    $budgetsFreq.each(function() {
                        $(this).html(frq + "ly");
                    });
                    var max = 30000;
                    max = max.fromPeriod('year').toPeriod($(this).val());
                    $budgetsCustom.attr('data-max', max).trigger('change').trigger('blur');
                    RetirementNeeds.Cards.updateCards();
                });
                $returns.on('blur', function() {
                    var num = $(this).val().reverseFormatMoneyPercentage(); //we remove dollar if dollar
                    var from = parseFloat($(this)[0].getAttribute('data-min')),
                        to = parseFloat($(this)[0].getAttribute('data-max'));
                    if (num < from) num = from;
                    if (num > to) num = to;
                    num = parseFloat(num).formatMoneyPercentage(2);
                    $(this).val(num);
                    //copy in form for submission
                    RetirementNeeds.Calculations.results();
                });
                $inflation.on('blur', function() {
                    var num = $(this).val().reverseFormatMoneyPercentage(); //we remove dollar if dollar
                    var from = parseFloat($(this).attr('data-min')),
                        to = parseFloat($(this).attr('data-max'));
                    if (num < from) num = from;
                    if (num > to) num = to;
                    num = parseFloat(num).formatMoneyPercentage(1);
                    $(this).val(num);
                    //copy in form for submission
                    RetirementNeeds.Calculations.results();
                });
                $assReset.on('click', function() {
                    $returns.val($returns[0].defaultValue);
                    $inflation.val($inflation[0].defaultValue);
                    RetirementNeeds.Calculations.results();
                });
                $reset.on('click', function(e) {
                    e.preventDefault();
                    $needsForm.find('input').each(function() {
                        $(this).val($(this)[0].defaultValue);
                    })
                    RetirementNeeds.Form.couplesSelection = null
                    RetirementNeeds.Form.retirementNeedsKnowSelection = null
                    $help.hide()
                    $incomeBox.hide()
                    RetirementNeeds.Navigate.moveBack(1)
                    RetirementNeeds.Form.clearValidation(1)
                    RetirementNeeds.Form.clearValidation(2)
                    RetirementNeeds.Form.clearValidation(3)
                    RetirementNeeds.Form.clearValidation(4)
                    RetirementNeeds.FancyRadio.reset() //uncheck checked radio options
                    $goToFormBtn.addClass('disabled')
                    $readTerms.prop('checked', false)
                    $preFormStep.show()
                    $needsFormRnBody.hide()
                });
            }
        },
        Form: {
            couplesSelection: null,
            retirementNeedsKnowSelection: null,
            validateStep(step) {
                $needsForm.foundation('validateForm');
                var currentStep = $steps.filter("[data-step='" + step + "']");
                if (currentStep.find(':input[data-invalid]').length == 0) return true;
                else return false;
            },
            clearValidation(step) {
                var nextStep = $steps.filter("[data-step='" + step + "']");
                nextStep.find(':input[data-invalid]').each(function() {
                    $needsForm.foundation('removeErrorClasses', $(this));
                });
            },
            showStep(step) {
                $steps.removeClass('js-show-step').addClass('js-hide-step');
                $steps.filter("[data-step='" + step + "']").removeClass('js-hide-step').addClass('js-show-step');
                $("html, body").animate({
                    // 130 is the height of the header, this seems arbritrary and could change
                    scrollTop: $needsContainer.offset().top - 130,
                }, 200);
            },
            updateIndex(step) {
                $stepIndex.val(20 * step);
            },
        },
        Navigate: {
            init() {
                $stepBack.on('click', function(e) {
                    e.preventDefault();
                    const step = $(this).data('gostep');
                    RetirementNeeds.Navigate.moveBack(step);
                });
                $stepNext.on('click', function(e) {
                    e.preventDefault();
                    const step = $(this).data('gostep');
                    RetirementNeeds.Navigate.moveForward(step);
                });
            },
            moveBack(step) {
                RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Navigation', 'Back to step ' + step);
                RetirementNeeds.GA.trackPistol('calculator_use','Retirement needs calc',step);
                switch (step) {
                    case 1: // checks to move to step 1
                        RetirementNeeds.Form.showStep(1);
                        RetirementNeeds.Form.updateIndex(1);
                        $asfa.hide();
                        break;
                    case 2: // checks to move to step 2
                        RetirementNeeds.Form.showStep(2);
                        RetirementNeeds.Form.updateIndex(2);
                        $asfa.hide();
                        break;
                    case 3: // checks to move to step 3
                        if (RetirementNeeds.Form.retirementNeedsKnowSelection == "dont-know") {
                            RetirementNeeds.Form.showStep(3);
                            RetirementNeeds.Form.updateIndex(3);
                            $asfa.show();
                        } else {
                            RetirementNeeds.Form.showStep(2);
                            RetirementNeeds.Form.updateIndex(2);
                            $asfa.hide();
                        }
                        break;
                    case 4: // checks to move to step 4
                        if (RetirementNeeds.Form.couplesSelection === "yes") {
                            console.log('Reached step 4 with couplesSelection == yes') // wt??
                        }
                        RetirementNeeds.Form.showStep(4);
                        RetirementNeeds.Form.updateIndex(4);
                        $asfa.hide();
                        break;
                    default:
                        return false;
                }
            },
            moveForward(step) {
                switch (step) {
                    case 2: // checks to move to step 2
                        if (RetirementNeeds.Form.validateStep(1)) {
                            $retirementNeedsPartner.each(function(id, el) {
                                if ($(el).is(':checked')) { // Check if include partner is checked
                                    RetirementNeeds.Form.couplesSelection = $(el).val()
                                    // Modify content for step 3 based on couples input value on step one
                                    if (RetirementNeeds.Form.couplesSelection === 'yes') {
                                        $singleOrCoupleElement.text('couple')
                                    } else {
                                        $singleOrCoupleElement.text('single person')
                                    }
                                }
                            })
                            RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Navigation', 'Next to step 2');
                            RetirementNeeds.GA.trackPistol('calculator_use','Retirement needs calc',2);
                            RetirementNeeds.Form.clearValidation(2);
                            RetirementNeeds.Cards.updateCards();
                            RetirementNeeds.Form.showStep(2);
                            RetirementNeeds.Form.updateIndex(2);
                            $asfa.hide();
                        } else {
                            return false;
                        }
                        break;
                    case 3: // checks to move to step 3
                        RetirementNeeds.Form.clearValidation(1);
                        if (RetirementNeeds.Form.retirementNeedsKnowSelection == "dont-know") {
                            RetirementNeeds.Form.clearValidation(2)
                            RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Navigation', 'Next to step 3');
                            RetirementNeeds.GA.trackPistol('calculator_use','Retirement needs calc',3);
                            RetirementNeeds.Form.clearValidation(3);
                            RetirementNeeds.Form.showStep(3);
                            RetirementNeeds.Form.updateIndex(3);
                            $asfa.show();
                        } else if (RetirementNeeds.Form.validateStep(2)) {
                            RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Navigation', 'Next to step 4');
                            RetirementNeeds.GA.trackPistol('calculator_use','Retirement needs calc',4);
                            RetirementNeeds.Form.clearValidation(4);
                            RetirementNeeds.Form.showStep(4);
                            RetirementNeeds.Form.updateIndex(4);
                            $asfa.hide();
                        } else {
                            return false;
                        }
                        break;
                    case 4: // checks to move to step 4
                        if (RetirementNeeds.Form.validateStep(3)) {
                            RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Navigation', 'Next to step 4');
                            RetirementNeeds.GA.trackPistol('calculator_use','Retirement needs calc',4);
                            RetirementNeeds.Form.clearValidation(4);
                            RetirementNeeds.Form.showStep(4);
                            RetirementNeeds.Form.updateIndex(4);
                            $asfa.hide();
                        } else {
                            return false;
                        }
                        break;
                    case 5: // checks to move to step 5
                        if (RetirementNeeds.Form.validateStep(4)) {
                            RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Navigation', 'Next to step 5 (completion)');
                            RetirementNeeds.GA.trackPistol('calculator_complete','Retirement Needs calc',5);
                            RetirementNeeds.Form.clearValidation(5);
                            RetirementNeeds.Calculations.results();
                            RetirementNeeds.Form.showStep(5);
                            RetirementNeeds.Form.updateIndex(5);
                            $asfa.hide();
                            $('.ga-retirement-calc-cta').on('click', function(ev){
                                ga4.trackEvnt('retirement_needs_calculator', {'conversion_type': 'completion - Book a time'})
                            })
                        } else {
                            return false;
                        }
                        break;
                    default:
                        return false;
                }
            }
        },
        Calculations: {
            results() {
                let res_netreturn = parseFloat($returns.val().reverseFormatMoneyPercentage()) / 100,
                    res_inflation = parseFloat($inflation.val().reverseFormatMoneyPercentage()) / 100,
                    res_realreturn = (1 + res_netreturn) / (1 + res_inflation) - 1,
                    res_budgets = 0;
                if (RetirementNeeds.Form.retirementNeedsKnowSelection == "dont-know") {
                    res_budgets = parseInt($budgetsTotal.val());
                } else {
                    let incomeAmount = $income.val();
                    if (incomeAmount) {
                        res_budgets = parseInt(incomeAmount.reverseFormatMoney()).fromPeriod($incomeFreq.val()).toPeriod('year');
                    }
                }
                const res_plans = parseInt($lumpsumTotal.val().reverseFormatMoney()),
                    to = 92, //@simone 12/2022, with rg276 this goes to a fixed 92
                    res_years = parseInt(to) - parseInt($retireAge.val())
                let res_startofyear = res_budgets,
                    res_assetRate = sgyConsumer.feePensionAssetPerc,
                    res_fixedfee = sgyConsumer.feePensionFixedDollar,
                    res_endofyear = 0,
                    res_returns = 0,
                    res_assetfee = 0
                for (var i = 0; i < res_years; i++) {
                    res_endofyear = res_startofyear;
                    res_returns = res_endofyear * res_realreturn;
                    res_assetfee = res_endofyear * res_assetRate;
                    res_startofyear = res_endofyear + res_budgets - res_returns + res_assetfee  + res_fixedfee;
                }
                res_startofyear += res_plans;
                res_startofyear = Formatters.roundToNearestRounding(res_startofyear)
                $results.find('.results-exp').html(to);
                $('.results-balance').html(res_startofyear.formatMoney(0));
                if (res_budgets) {
                    $results.find('.results-income').html(res_budgets.formatMoney(0));
                }
                $results.find('.results-years').html(res_years);
                $results.find('.results-lumpsum').html(res_plans.formatMoney(0));
            }
        },
        Plugins: {
            sliderInit() {
                $('.js-rn-slider-for').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    draggable: false,
                    arrows: false,
                    fade: true,
                    dots: true,
                    dotsClass: 'js-rn-slider-dots rn-slider-dots menu',
                    customPaging: function(slider, i) {
                        var slideNumber = (i + 1),
                            totalSlides = slider.slideCount;
                        return '<a class="js-rn-slider-dot rn-slider-dots--item" title="' + slideNumber + ' of ' + totalSlides + '"></a>';
                    },
                    asNavFor: '.js-rn-slider-nav',
                });
                $('.js-rn-slider-nav').slick({
                    slidesToShow: 9,
                    infinite: false,
                    draggable: false,
                    asNavFor: '.js-rn-slider-for',
                    dots: false,
                    arrows: false,
                    focusOnSelect: true,
                    vertical: true
                });
            }
        },
        GA: {
            init() {
                $retireAge.on('blur', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 1', 'Retirement age');
                });
                $retirementNeedsKnow.on('change', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 2', 'When I retire' + ' - ' + RetirementNeeds.Form.retirementNeedsKnowSelection);
                });
                $income.on('blur', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 2', 'Income');
                });
                $incomeFreq.on('change', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 2', 'Income frequency' + ' - ' + $(this).val());
                });
                $frequency.on('change', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 3', 'Lifestyle budget frequency' + ' - ' + $(this).val());
                });
                $reset.on('click', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Navigation', 'Reset');
                });
                $dip.on('change', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 4', 'Dip into super' + ' - ' + $(this).val());
                });
                $lumpsums.on('blur', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Step 4', 'Lumpsum' + ' - ' + $(this).data('ga-label'));
                });
                $('.ga-retirement-calc-assumption-action').on('click', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Assumptions', 'Open');
                });
                $returns.on('blur', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Assumptions', 'Investment returns');
                });
                $inflation.on('blur', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Assumptions', 'Inflation');
                });
                $assReset.on('click', function() {
                    RetirementNeeds.GA.track('Retirement Needs Calculator 2021', 'Assumptions', 'Reset');
                });
                RetirementNeeds.GA.trackPistol('calculator_use','Retirement needs calc',1);
            },
            track(category, action, opt_label, opt_value) {
                ga('send', 'event', category, action, opt_label, opt_value);
                // console.log('GA.track: ', {category, action, opt_label, opt_value})
            },
            trackPistol(evtype, name, step) {
                window.dataLayer.push({
                  event: evtype,
                	calculator_name: name,
                	step_number: step,
                	step_name: "Step "+step,
                 });
            },
            filterG4Params(type, value) {
                let bracketed;
                switch (type) {
                    case 'age':
                        if (value <= 24) {
                            bracketed = "18-24";
                        } else if (value >= 25 && value <= 34) {
                            bracketed = "25-34";
                        } else if (value >= 35 && value <= 44) {
                            bracketed = "35-44";
                        } else if (value >= 45 && value <= 54) {
                            bracketed = "45-54";
                        } else if (value >= 55 && value <= 64) {
                            bracketed = "55-64";
                        } else {
                            bracketed = "65+";
                        }
                        break;
                    case 'gender':
                        if (value == "M") {
                            bracketed = 'Male';
                        } else {
                            bracketed = 'Female';
                        }
                        break;
                    case 'income':
                        if (value <= 48000) {
                            bracketed = "Low income";
                        } else if (value >= 48001 && value <= 90000) {
                            bracketed = "Medium income";
                        } else {
                            bracketed = "High income";
                        }
                        break;
                    case 'balance':
                        if (value <= 50000) {
                            bracketed = "Low balance";
                        } else if (value >= 50001 && value <= 150000) {
                            bracketed = "Medium balance";
                        } else {
                            bracketed = "High balance";
                        }
                        break;
                    default:
                        return 'error';
                }
                // console.log('GA.filterG4Params: ', {bracketed})
                return bracketed
            }
        }
    },
    App = {
        Initialize(obj) {
            $.each(obj, function(key, value) {
                if (value) {
                    if (key == "init" && typeof value == "function") {
                        //this runs each of the init methods in the RetirementNeeds Object on load
                        // a class constructor would be better
                        value.call(obj);
                    } else if (typeof value == "object") {
                        App.Initialize(value)
                    }
                }
            })
        }
    }
    App.Initialize(RetirementNeeds)
    let sliderLoaded = false
    $readTerms.on('click', function(){
        if($readTerms.is(':checked')){
            $goToFormBtn.removeClass('disabled')
        } else {
            $goToFormBtn.addClass('disabled')
        }
    })
    $goToFormBtn.on('click', function(){
        if($readTerms.is(':checked')){
            $preFormStep.hide()
            $needsFormRnBody.show()
            if(sliderLoaded === false) {
                sliderLoaded = true
                RetirementNeeds.Plugins.sliderInit() // need to set the slider width once the form body is visible
            }
            $("html, body").animate({
                scrollTop: $needsContainer.offset().top - 130,
            }, 200);
        }
    })
    $backToPreForm.on('click', function(){
        $preFormStep.show()
        $needsFormRnBody.hide()
    })
    Number.prototype.formatMoney = function(c, d, t) {
        var n = this,
            s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        c = isNaN(c = Math.abs(c)) ? 2 : c;
        d = d === undefined ? "." : d;
        t = t === undefined ? "," : t;
        return '$' + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }
    Number.prototype.formatMoneyNOD = function(c, d, t) {
        var n = this,
            s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        c = isNaN(c = Math.abs(c)) ? 2 : c;
        d = d === undefined ? "." : d;
        t = t === undefined ? "," : t;
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }
    Number.prototype.formatMoneyPercentage = function(c, d, t) {
        var n = this,
            s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        c = isNaN(c = Math.abs(c)) ? 2 : c;
        d = d === undefined ? "." : d;
        t = t === undefined ? "," : t;
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "") + '%';
    };
    String.prototype.reverseFormatMoney = function() {
        var n = this;
        return n.replace(/[^0-9]/g, '');
    };
    String.prototype.reverseFormatMoneyPercentage = function() {
        var n = this;
        return n.replace(/[^0-9\.]/g, '');
    }
    //takes yearly amount and turns it into various
    Number.prototype.toPeriod = function(s) {
        s = typeof s !== "undefined" ? s : "year";
        var n = this;
        if (s == "year") {
            return (n);
        } else if (s == "month") {
            return (n / 12);
        } else if (s == "fortnight") {
            return (n / 26.1);
        } else if (s == "week") {
            return (n / 52.2);
        }
    }
    //takes various amounts and turns it into yearly
    Number.prototype.fromPeriod = function(s) {
        s = typeof s !== "undefined" ? s : "year";
        var n = this;
        if (s == "year") {
            return (n);
        } else if (s == "month") {
            return (n * 12);
        } else if (s == "fortnight") {
            return (n * 26.1);
        } else if (s == "week") {
            return (n * 52.2);
        }
    };
    var _gaq = []
});
//<!-- Copyright © Spark Green Pty Ltd Australia -->
